const postProcessorConfig = {
  title: "Configurar procesador",
  configured_processors_for: "Procesadores configurados para",
  table: "Tabla",
  no_processors_configured:
    'No hay procesadores configurados para este campo. Haga clic en "+ Crear nuevo procesador" abajo.',
  create_new_processor: "Crear nuevo procesador",
  processor_type: "Tipo de procesador",
  lookup_conditions: "Condiciones de búsqueda",
  lookup_conditions_description:
    "Las entradas que comparten el mismo groupId se combinan mediante la operación AND. Los diferentes groupIds son opciones alternativas que se prueban en orden: prevalece el primer grupo que coincida. Para TableLevel, lookupField se resuelve primero con la fila actual y, si no, se recurre al encabezado.",
  properties_to_copy: "Propiedades para copiar",
  properties_to_copy_description:
    "Para cada entrada, el valor de predefineFieldProperty en el ExpectedValue coincidente se escribe en destinationField en el documento (encabezado o fila, según el ámbito).",
  processor_name: "Nombre del procesador",
  lookup_predefined_values_copy_properties:
    "buscar valores predefinidos, copiar propiedades",
  processor_name_required: "El nombre del procesador es obligatorio",
  group_id: "ID de grupo",
  lookup_field: "Campo de búsqueda",
  predefined_value: "Valor predefinido",
  predefined_field_property: "Propiedad del campo predefinido",
  lookup_predefined_field_property:
    "Propiedad del campo predefinido de búsqueda",
  semantic: "Semántico",
  destination_field: "Campo de destino",
  lookup_field_required: "El campo de búsqueda es obligatorio",
  lookup_property_required: "La propiedad de búsqueda es obligatoria",
  predefined_value_required: "El valor predefinido es obligatorio",
  predefined_field_property_required:
    "La propiedad del campo predefinido es obligatoria",
  destination_required: "El campo de destino es obligatorio",
  at_least_one_lookup: "Se requiere al menos una configuración de búsqueda",
  group_id_required: "El ID de grupo es obligatorio",
  order_required: "El orden es obligatorio",
  add_lookup_condition: "Agregar condición de búsqueda",
  add_copy_entry: "Agregar entrada de copia",
  auto_selection: "Selección automática",
  processor_updated_successfully: "Procesador actualizado con éxito",
  processor_created_successfully: "Procesador creado con éxito",
  delete_processor: "Eliminar procesador",
  delete_confirmation:
    "¿Está seguro de que desea eliminar el procesador {{processorName}}?",
  confirm: "Confirmar",
  cancel: "Cancelar",
  processor_deleted_successfully: "Procesador eliminado exitosamente",
  mode: "Modo",
  lookup: "Búsqueda",
  constant: "Constante",
  lookup_predefined_field_property_placeholder: "Valor constante",
  constant_value_required: "El valor constante es obligatorio",
  consistent_field: "Campo consistente",
  consistent_field_description:
    "valores de campo consistentes, valores de copia",
  basic_information: "Información básica",
  header_seeding: "Siembra de encabezado",
  consider_header_field: "Considerar el campo de encabezado",
  consider_header_field_description:
    "Cuando está activado, el campo de encabezado siembra la parte superior de la cascada (su valor llena la primera fila vacía, luego los valores fluyen hacia las filas vacías posteriores). Cuando está desactivado, las celdas vacías solo heredan de la fila anterior.",
  bottom_seeding: "Propagación desde la parte inferior",
  consider_bottom_field: "Considerar el campo inferior",
  consider_bottom_field_description:
    "Cuando está activado, el campo inferior inicia la propagación desde la parte inferior de la cascada (su valor llena la primera fila vacía y luego los valores se propagan hacia arriba a las filas anteriores). Cuando está desactivado, las celdas vacías solo heredan el valor de la fila inferior.",
  order: "Orden",
  save: "Guardar",
  next: "Siguiente",
  type: "Tipo",
  rule_type: "Tipo de regla",
  pattern: "Patrón (.NET Regex)",
  replace_with: "Reemplazar con",
  replace_with_description:
    "Solo se usa cuando el tipo de regla es Reemplazar. Si está vacío, elimina la coincidencia.",
  replace_only: "Solo reemplazar",
  conditions: "Condiciones",
  conditions_description:
    "Todas las condiciones deben cumplirse (AND), comparadas sin distinción entre mayúsculas y minúsculas. La regla solo se ejecuta cuando coinciden todas las condiciones. Una condición en la misma tabla que el destino se verifica por fila; una condición de encabezado controla toda la escritura.",
  field_name: "Campo",
  condition_value: "Valor (sin distinción entre mayúsculas y minúsculas)",
  add_condition: "Agregar condición",
  rule_type_replace: "Reemplazar",
  rule_type_match: "Coincidir",
  rule_type_required: "El tipo de regla es obligatorio",
  pattern_required: "El patrón es obligatorio",
  regex: "Regex",
  regex_description:
    "aplicar reglas de expresión regular a los valores del campo",
  prevent_reuse_of_already_selected_within_document:
    "Prevenir reutilización de ya seleccionados en el documento",
  prevent_reuse_of_already_selected_within_document_description:
    "Cuando está activado, las opciones que ya se hayan seleccionado en otra parte del documento no se reutilizarán.",
  generate_regex: "Generar Regex",
  generate_regex_subtitle:
    "Describe la transformación y proporciona un ejemplo: la IA generará el patrón por ti.",
  instructions: "Instrucciones",
  instructions_placeholder:
    "p. ej. Eliminar los ceros a la izquierda del valor",
  instructions_required: "Las instrucciones son obligatorias",
  before: "Antes",
  before_placeholder: "p. ej. 000123",
  before_required: "El valor de antes es obligatorio",
  after: "Después",
  after_placeholder: "p. ej. 123",
  after_required: "El valor de después es obligatorio",
  replace_value: "Valor de reemplazo",
  generate: "Generar",
  regex_generated_successfully: "Regex generada correctamente",
  regex_generation_failed:
    "No se pudo generar una regex. Ajusta los datos introducidos.",
  regex_validation_not_passed:
    "Regex generada, pero no produce el resultado esperado para todos los ejemplos. Revísala.",
  instructions_hint:
    'Indicaciones en lenguaje natural que le dicen a la IA qué extraer. Ejemplo: "Extrae solo los dígitos después del signo de dólar."',
  before_hint:
    'El texto del valor original del documento (p. ej. "Total Amount: $54.00").',
  after_hint: 'Lo que se debe extraer exactamente (p. ej. "54.00").',
  replace_value_hint:
    "Asigna un valor fijo cuando se activa la regla (p. ej. asignar 'Unknown' a un campo).",
};

export default postProcessorConfig;
